import { useEffect, useState } from "react";
// Move to core
/**
 * useDebounce
 *
 * @param value - The input value to be debounced
 * @param delay - The debounce delay in milliseconds
 * @returns The debounced value
 */
export default function useDebounce<T>(value: T, delay: number): T {
	const [debouncedValue, setDebouncedValue] = useState<T>(value);

	useEffect(() => {
		// Set up a timer that will update the debounced value
		// if no changes to `value` occur during `delay` milliseconds
		const handler = setTimeout(() => {
			setDebouncedValue(value);
		}, delay);

		// If `value` changes or component unmounts, cancel the timer
		return () => {
			clearTimeout(handler);
		};
	}, [value, delay]);

	return debouncedValue;
}
